import { useMsal } from '@azure/msal-react';
import {
    CircularProgress, Grid,
    Paper, Typography
} from '@material-ui/core';
import Slider from '@material-ui/core/Slider';
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { globalStyles } from '../../../assets/globalStyles';
import { getKonfig, selectKonfig, selectKonfigLoading, setKonfigWert, updateKonfig } from './netzereignisseSlice';
import { useStyles } from './netzereignisseStyles';

export const NetzereignisseKonfig = (): JSX.Element => {

    const dispatch = useAppDispatch();
    const { instance } = useMsal();


    useEffect(() => {
        dispatch(getKonfig());
    }, [instance]);

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    const
        konfig = useAppSelector(selectKonfig),
        konfigLoading = useAppSelector(selectKonfigLoading);


    return (

        <Paper className={classes.paper} >
            <Grid container spacing={2} >
                <Grid item md={12} style={{ marginBottom: "25px" }}>
                    <Typography color="primary" variant="h6" className={classes.typoH6Style} style={{ marginLeft: "20px" }}>
                        Konfigurationseinstellung
                    </Typography>
                </Grid>
                {konfigLoading ? <Grid item md={12} style={{ marginBottom: "20px" }}><CircularProgress size="30px" style={{ alignSelf: "center" }} /></Grid> : (
                    <Grid container spacing={5} style={{ marginLeft: "10px", marginBottom: "20px" }} >
                        <Grid item>
                            <Typography style={{ textAlign: "left" }}>
                                Wochenanzeige auf der Startseite:
                            </Typography>
                        </Grid>
                        <Grid item md={8} style={{ textAlign: "left" }}>
                            <Slider style={{ maxWidth: "60%" }}
                                value={Number(konfig.wert)}
                                aria-labelledby="discrete-slider"
                                valueLabelDisplay="on"
                                onChange={(_, nV) => {
                                    dispatch(setKonfigWert(nV.toString()));
                                }}
                                onChangeCommitted={() => {
                                    dispatch(updateKonfig(konfig));
                                }}
                                step={2}
                                marks
                                min={2}
                                max={16}
                            />
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </Paper>


    )
}
